<template>
  <section class="iam">
    <bacon title="I am..."></bacon>
    <div class="services">
      <div class="service" v-for="service in services">
        <img :src="'/dist/' + service.icon" />
        <h3 v-html="service.title" class="two-line-heading">></h3>
        <p class="description">{{ service.text }}</p>
      </div>
    </div>
  </section>
</template>

<script>
  require.context('../../assets/iam-icons/', true);
  import Bacon from './bacon.vue'

  export default {
    components: {Bacon},

    props: {
      id: String,
      name: String,
    },

    data () {
      return {
        services: [
          {
            icon: `icon-print.svg`,
            title: `Professional <span>Print Designer</span>`,
            text: `Image and typography are important in every business.
                Bold logo design paired with professional stationery packages ensure you
                always have a competitive advantage. Creating recognizable and strong brands
                is what I do. From business cards & brochures to
                large posters and packaging solutions. `,
          },
          {
            icon: 'icon-web.svg',
            title: 'Experienced  <span>Web Designer</span>',
            text: `When I work on a website, I concentrate on the design, usability and
                tiny details that usually make a big difference between ordinary and
                extraordinary sites. I create modern and clean user interface accompanied
                by a responsive layout that looks good on all screen sizes.`,
          },
          {
            icon: 'icon-misc.svg',
            title: 'Movie arts &amp; Beer <span>Lover</span>',
            text: 'In my free time, I enjoy visiting museums and galleries, watching movies,' +
            ' cuddling with shelter animals, or simply drinking craft beers with my friends. ',
          },
        ]
      }
    },

    mounted: function () {
    }
  }
</script>

<style lang="scss">
  // TODO: move this to the index
  @import "../../css/iam.scss";
</style>


// WEBPACK FOOTER //
// iam.vue?c581ae1e